import _ from 'lodash';
import React, { useMemo } from 'react';
import { BusinessUnitFilter, DisciplineFilter, LocationFilter, PracticeFilter, SkillFilter } from '~/components';
import ResourceStatusFilter from '../../routes/app/resources/allocations/member-schedule/filters/ResourceStatusFilter';
import ResourceTypeFilter from '../../routes/app/resources/allocations/member-schedule/filters/ResourceTypeFilter';

export default function ResourceFiltersBar({ filters, sticky, onChange }) {
  const visible = useMemo(() => {
    const isVisible = (key) => sticky?.includes(key) || !_.isEmpty(filters[key]);

    return {
      resourcePractices: isVisible('resourcePractices'),
      resourceBusinessUnits: isVisible('resourceBusinessUnits'),
      resourceDisciplines: isVisible('resourceDisciplines'),
      resourceLocations: isVisible('resourceLocations'),
      resourceSkills: isVisible('resourceSkills'),
      resourceStatusId: isVisible('resourceStatusId'),
      resourceTypeId: isVisible('resourceTypeId'),
    };
  }, [filters, sticky]);

  return (
    <>
      {visible.resourcePractices && (
        <PracticeFilter
          placeholder="Resource Practice"
          value={filters.resourcePractices}
          onChange={({ target: { value } }) => onChange({ resourcePractices: value })}
        />
      )}

      {visible.resourceBusinessUnits && (
        <BusinessUnitFilter
          placeholder="Resource Business Unit"
          value={filters.resourceBusinessUnits}
          onChange={({ target: { value } }) => onChange({ resourceBusinessUnits: value })}
        />
      )}

      {visible.resourceDisciplines && (
        <DisciplineFilter
          placeholder="Resource Discipline"
          value={filters.resourceDisciplines}
          onChange={({ target: { value } }) => onChange({ resourceDisciplines: value })}
        />
      )}

      {visible.resourceLocations && (
        <LocationFilter
          placeholder="Resource Location"
          value={filters.resourceLocations}
          onChange={({ target: { value } }) => onChange({ resourceLocations: value })}
        />
      )}

      {visible.resourceSkills && (
        <SkillFilter
          placeholder="Resource Skills"
          value={filters.resourceSkills}
          onChange={({ target: { value } }) => onChange({ resourceSkills: value })}
        />
      )}

      {visible.resourceStatusId && (
        <ResourceStatusFilter
          value={filters.resourceStatusId}
          onChange={({ target: { value } }) => onChange({ resourceStatusId: value })}
        />
      )}

      {visible.resourceTypeId && (
        <ResourceTypeFilter
          value={filters.resourceTypeId}
          onChange={({ target: { value } }) => onChange({ resourceTypeId: value })}
        />
      )}
    </>
  );
}
